import { StatCard } from '../StatCard'
import { CollapsibleSection } from './CollapsibleSection'
import { ChartBarIcon } from '@heroicons/react/24/outline'
import type { ComponentType } from 'react'

type StatItem = {
  label: string
  value: string
  hint: string
  proOnly: boolean
  icon?: ComponentType<{ className?: string }>
  valueTooltip?: string
}

type Props = {
  statItems: StatItem[]
  isLoadingApps: boolean
  isPro: boolean
  compact?: boolean
  collapsible?: boolean
}

export const StatsSection = ({ statItems, isLoadingApps, isPro, compact = false, collapsible = false }: Props) => {
  const content = (
    <section className={compact ? "h-full grid grid-cols-2 gap-2" : "grid gap-3 sm:grid-cols-3 xl:grid-cols-4"}>
      {statItems.map((item) => (
        <StatCard
          key={item.label}
          label={item.label}
          value={item.value}
          hint={item.hint}
          valueTooltip={item.valueTooltip}
          icon={item.icon}
          isLoading={isLoadingApps}
          proOnly={item.proOnly}
          isPro={isPro}
          compact={compact}
        />
      ))}
    </section>
  )

  if (collapsible) {
    return (
      <CollapsibleSection title="Statistics" icon={ChartBarIcon} storageKey="dashboard-stats-expanded" defaultExpanded={false}>
        {content}
      </CollapsibleSection>
    )
  }

  return content
}
